<template>
  <div class="container-fluid">
    <div class="d-flex align-items-center">
      <h2 class="page-heading mr-auto"><back-button to="/orders/ingredients"/>Новая заявка</h2>
      <btn-action :disabled="selectedOperator === null" class="btn btn-primary" @click="save">Оформить заявку</btn-action>
    </div>
    <div class="card mb-3">
      <h3 class="card-header"><span class="text-caps">Оператор</span></h3>
      <div class="card-body" style="max-width: 28rem;">
        <server-select
          v-model="selectedOperator"
          :custom-label="fullName"
          endpoint="users_by_role"
          :endpoint-params="{role: ['service']}"
        />
      </div>
    </div>
    <div class="row" v-if="selectedOperator">
      <div class="col-md-6">
        <div class="card">
          <h3 class="card-header"><span class="text-caps">Автоматы для расчета</span></h3>
          <div class="card-body">
            <server-select
              class="select-machines-orders-ingredients-create"
              v-model="selectedMachines"
              endpoint="orders/machines"
              :endpoint-params="{operator_id: selectedOperator.id}"
              :multiple="true"
              label="serial_number"
              :custom-label="(machine) => `${machine.serial_number} – ${machine.address}`"
            />
            <table class="table table-sm px-0 mt-2 mb-0" v-if="selectedMachines && selectedMachines.length">
              <tr v-for="(machine, index) in selectedMachines">
                <td style="vertical-align: middle;"><strong>{{machine.serial_number}}</strong></td>
                <td style="vertical-align: middle;">{{machine.address}}</td>
                <td width="1">
                  <button class="btn btn-sm btn-outline-danger" @click="deleteMachine(index)">&times; Удалить</button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <h3 class="card-header"><span class="text-caps">Суммарное количество необходимых ингредиентов</span></h3>
          <div class="card-body">
            <table class="table table-sm px-0 mt-2 mb-0" v-if="ingredients && ingredients.length">
              <tr v-for="(ingredient, index) in ingredients">
                <td style="vertical-align: middle;"><strong>{{index + 1}}</strong></td>
                <td style="vertical-align: middle;"><strong>{{ingredient.component.name}}</strong></td>
                <td style="vertical-align: middle;">
                  {{ingredient.need | remainder}} {{ingredient.component.measure}}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import filters from '../../../filters'

  export default {
    metaInfo: {title: 'Новая заявка на ингредиенты'},
    data () {
      return {
        selectedOperator: null,
        selectedMachines: [],
      }
    },
    computed: {},
    methods: {
      fullName: filters.fullName,
      save () {
        return api.post('orders/ingredients', {
          user_id: this.selectedOperator.id,
          request: this.ingredients.map((current) => {
            return {
              amount: current.need,
              component_id: current.component.id,
            }
          }),
        }).then(() => {
          this.$router.push('/orders/ingredients')
        })
      },
      deleteMachine (index) {
        this.selectedMachines.splice(index, 1)
      },
    },
    watch: {
      selectedOperator () {
        this.selectedMachines = []
      },
    },
    asyncComputed: {
      ingredients () {
        return api.post('orders/need', {
          machines: this.selectedMachines.map((current) => current.id),
        }).then(({data}) => data.data)
      },
    },
  }
</script>

<style lang="scss">
  .select-machines-orders-ingredients-create {
    .multiselect__tag {
      max-width: 7.2em;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/orders/ingredients/create.vue